<template>
  <div class="diadin">
    <el-button type="primary" style="margin-bottom: 20px" @click="handleEdit(1)">{{ $t('menu.AddAccount') }}</el-button>
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="userName" :label="$t('menu.user')"></el-table-column>

      <el-table-column prop="email">
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.EmailAddress') }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="roles">
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.Role') }}</div>
        </template>

        <template slot-scope="scope">
          <div v-if="scope.row.roles[0] !== undefined">
            {{ scope.row.roles[0].roleName }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column>
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.Operation') }}</div>
        </template>

        <template slot-scope="scope">
          <el-button type="text" size="mini" v-if="scope.row.roles[0].roleId!==10000" @click="handleEdit(2, scope.row)" style="font-weight: 400;">{{
            $t('menu.Edit') }}</el-button>
          <el-button type="text" size="mini" v-if="scope.row.roles[0].roleId!==10000" @click="handleEdit(4, scope.row)" style="font-weight: 400;">{{
            $t('menu.ChangePassword') }}</el-button>
          <el-button type="text" size="mini" v-if="scope.row.roles[0].roleId!==10000" @click="handleEdit(3, scope.row)" style="font-weight: 400;">{{
            $t('menu.Delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, prev, pager, next" :total="totale">
      </el-pagination>
    </div>

    <el-dialog :title="titleaa" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <div class="ccca" style=" margin: 0 auto">
        <el-form ref="formInline" :model="formInline" label-width="130px">
          <!-- <el-form-item label="用户名称" v-if="titleaa !== $t('menu.ChangePassword')">
          </el-form-item>
          <el-input v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.nickName"></el-input> -->
          <el-form-item :label="$t('menu.user')" required v-if="titleaa !== $t('menu.ChangePassword')">
          </el-form-item>
          <el-input v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.userName"
            :disabled="doingtype == 2"></el-input>
          <el-form-item required :label="$t('menu.EmailAddress')" v-if="titleaa !== $t('menu.ChangePassword')">
            <!-- <template slot="label">
              <div>{{ $t('menu.EmailAddress') }}</div>
            </template> -->
          </el-form-item>
          <el-input v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.email"
            :disabled="doingtype == 2"></el-input>
          <el-form-item required :label="$t('menu.Password')" v-if="doingtype !== 2">
            <!-- <template slot="label" >
              <div>{{ $t('menu.Password')}} </div>
            </template> -->
          </el-form-item>
        
          <el-input v-if="doingtype != 2 && titleaa !== $t('menu.ChangePassword')"
            v-model="formInline.password"></el-input>
          <el-input v-if="doingtype != 2 && titleaa == $t('menu.ChangePassword')" v-model="oldPassworda"></el-input>
           <el-form-item label="erp"  v-if="titleaa !== $t('menu.ChangePassword')&&tup=='1'">
          </el-form-item>
          <el-input v-if="titleaa !== $t('menu.ChangePassword')&&tup=='1'" v-model="formInline.erpCode"
           ></el-input>
          <el-form-item required :label="$t('menu.Role')" style="margin-top: 10px;"
            v-if="titleaa !== $t('menu.ChangePassword')">
            <!-- <template slot="label" >
              <div>{{ $t('menu.Role') }}</div>
            </template> -->
          </el-form-item>
          <el-select v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.roleIds"
            :placeholder="$t('menu.Role')">
            <el-option v-for="(item, index) in rolelist" :key="index" :label="item.roleName"
              :value="item.roleId"></el-option>
          </el-select>
          <el-form-item v-if="formInline.roleIds.length != 0 && titleaa !== $t('menu.ChangePassword')">
            <!-- <div v-if="titleaa == '编辑账号'"> -->
            {{ remk(formInline.roleIds) }}
            <!-- </div> -->
          </el-form-item>
        </el-form>
        <div style=" margin: 30px auto" class="er">
          <el-button v-if="doingtype == 1 || titleaa == $t('menu.ChangePassword')" type="primary" @click="updata"
            class="er">{{ $t('menu.Confirm') }}</el-button>
          <el-button v-if="doingtype == 2" type="primary" @click="putdata" class="er">{{ $t('menu.Confirm')
            }}</el-button>

        </div>
      </div>
    </el-dialog>

    <el-dialog :title="$t('menu.DeleteAccount')" :visible.sync="delType" width="20%">
      <div style="display: flex; justify-content: center;">
        {{ $t('menu.DelAc') }}
      </div>
      <div style="margin-top: 30px;display: flex; justify-content: center;">
        <el-button type="primary" @click="deleteU" style="width: 130px;">{{ $t('menu.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dealerUserlist, dealerUserauthRole, updatadealerUser, putdealerUser, deleteUser, dealerUserresetPwd } from "../../api/api";

export default {
  data () {
    return {
      oldPassworda: '',
      delType: false,
      dialogVisible: false,
      rolelist: [],
      doingtype: 1,
      action: 0,
      activeName: "0",
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      activeName: "first",
      mation: [], //列表
      formInline: {
        userName: '',
        nickName: "",
        email: "",
        password: "",
        roleIds: [],
      },
      remark: '',
      titleaa: '添加账户',
      tup:'1',
    };
  },
  created () {
    this.biao();
    this.role()
    this.tup=sessionStorage.getItem('platform')
  },
  computed: {

  },
  methods: {
    remk (e) {
      let a = this.rolelist
      console.log(e);

      a.forEach(r => {
        if (e == r.roleId&&r.remark!==null) {
          this.remark = r.remark.replace('/"\n"/g,', ",")
        }
      })
      return this.remark
    },
    deleteU () {
      let param = new URLSearchParams();
      deleteUser(param, this.formInline.userId).then(r => {
        if (r.data.code == 200) {
          this.$message.success(r.data.msg)
        } else {
          this.$message.error(r.data.msg)
        }
        this.delType = false
        this.biao();
      })
    },
    handleClose () {
      this.formInline = {
        userName: '',
        nickName: "",
        email: "",
        password: "",
        roleIds: [],

      }
      this.dialogVisible = false

    },
    async biao () {
      let param = new URLSearchParams();

      const { data: res } = await dealerUserlist(
        param,
        this.currentPage3,
        this.pagesize
      );
      console.log(res);

      this.mation = res.rows;
      this.totale = res.total;
    },

    //角色列表
    async role () {
      let param = new URLSearchParams();
      const { data: res } = await dealerUserauthRole(param);
      console.log(res);

      this.rolelist = res.roles;


    },
    //修改密码
    async updatePwd () {
      console.log(123123, this.oldPassworda);

      let param = {}
      param.password = this.oldPassworda
      param.userId = this.formInline.userId
      // param.password = this.formInline.password

      const { data: res } = await dealerUserresetPwd(param)
      if (res.code !== 200) return this.$message.error("修改失败")
      this.$message({
        message: '修改成功',
        type: 'success'
      });
      this.handleClose()
      this.biao()


    },
    //添加账号 
    async updata () {
      if (this.titleaa == this.$t('menu.ChangePassword')) {
        this.oldpassword = ""
        this.updatePwd()
      } else {


        if (this.formInline.roleIds.length == 0) {
          this.$message.error('请选择角色')
          reutrn
        } else if (this.formInline.password.length == 0) {
          this.$message.error('请填写密码')
          return
        }
        else {

          let param = this.formInline
          param.roleIds = [param.roleIds]
          param.nickName = this.formInline.userName
          const { data: res } = await updatadealerUser(param)
          if (res.code !== 200) return this.$message.error(res.msg)
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.handleClose()
          this.biao()
        }

      }
    },
    //编辑账号 
    async putdata () {
      if (this.formInline.roleIds.length == 0) {
        this.$message.error('请选择角色')
        reutrn
      } else {
        let param = this.formInline
        param.roleIds = [param.roleIds]

        const { data: res } = await putdealerUser(param)
        if (res.code !== 200) return this.$message.error("添加失败")
        this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.handleClose()
        this.biao()
      }


    },

    handleClick (tab, event) {
      console.log(tab, event);
    },
    //表单点击

    handleEdit (i, e) {
      if (i == 3) {

        this.delType = true
        this.formInline = e
      } else {
        this.dialogVisible = true
        this.doingtype = i
        this.titleaa = this.$t('menu.AddAccount')
        if (i !== 1) {

          this.titleaa = this.$t('menu.Edit')
          if (i == 4) { this.titleaa = this.$t('menu.ChangePassword') }
          this.formInline = e
          this.formInline.roleIds = []
          if (e.roles.length > 0) {
            this.formInline.roleIds = e.roles[0].roleId
            // e.roles.forEach(z => {
            //   this.formInline.roleIds.push(z.roleId)
            // });
          }
        }
      }
    },

    //搜索
    onSubmit () {
      this.biao();
    },

    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.biao();
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.ccca {
  width: 400px;
}

.er {
  width: 200px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-form-item {
  margin-bottom: 0 !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-form-item__label {
  text-align: left !important;
}

/deep/.el-table th.is-leaf {
  text-align: left;
  // background-color: #d7d7d7;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}

/deep/.el-form-item__content {
  margin-left: 0 !important;
}
</style>